// eslint-disable-next-line import/no-cycle
import { receivedSamplesFilters, symbolSearchFilters } from '@/config';
import { LAB_SAMPLE_STATUSES } from '@/config/constants';
import http from '@/services/http';
import tableHelper from '@/services/tableHelper';

const samples = {
  // @deprecated
  index(tableFilters, filterStatus, additionalFilters = {}, config = {}) {
    const filters = tableHelper.whereFilters(
      filterStatus,
      receivedSamplesFilters
    );
    if (filters.and) {
      filters.and.push(additionalFilters);
    } else {
      filters.and = [additionalFilters];
    }
    return http.request({
      method: 'get',
      url: '/samples',
      params: { filter: { ...tableFilters, where: filters } },
      ...config,
    });
  },
  received(tableFilters, filterStatus, additionalFilters = {}, config = {}) {
    const filters = tableHelper.whereFilters(
      filterStatus,
      receivedSamplesFilters
    );

    const { groupsOnly, ...otherFilters } = additionalFilters;

    if (filters.and) {
      filters.and.push(otherFilters);
    } else {
      filters.and = [otherFilters];
    }

    return http.request({
      method: 'get',
      url: '/checkin',
      params: {
        filter: JSON.stringify({
          ...tableFilters,
          where: filters,
        }),
        groupsOnly,
      },
      ...config,
    });
  },
  // received(tableFilters, filterStatus, additionalFilters = {}) {
  //   const filters = tableHelper.whereFilters(
  //     filterStatus,
  //     receivedSamplesFilters
  //   );
  //   if (filters.and) {
  //     filters.and.push(additionalFilters);
  //   } else {
  //     filters.and = [additionalFilters];
  //   }
  //   return http.request({
  //     method: 'get',
  //     url: '/checkin',
  //     params: { filter: { ...tableFilters, where: filters } },
  //   });
  // },
  receivedByGroups(groupingIds, tableFilters, filterStatus, config = {}) {
    const filters = tableHelper.whereFilters(
      filterStatus,
      receivedSamplesFilters
    );

    if (filters.and) {
      filters.and.push({ groupingId: { inq: groupingIds } });
    } else {
      filters.and = [{ groupingId: { inq: groupingIds } }];
    }

    return http.request({
      method: 'get',
      url: '/checkin/children',
      params: {
        filter: JSON.stringify({
          ...tableFilters,
          where: filters,
        }),
      },
      ...config,
    });
  },
  receivedByGroup(groupingId, tableFilters, filterStatus, config = {}) {
    const filters = tableHelper.whereFilters(
      filterStatus,
      receivedSamplesFilters
    );

    if (filters.and) {
      filters.and.push({ groupingId });
    } else {
      filters.and = [{ groupingId }];
    }

    return http.request({
      method: 'get',
      url: '/checkin/children',
      params: {
        filter: JSON.stringify({
          ...tableFilters,
          where: filters,
        }),
      },
      ...config,
    });
  },
  count(filterStatus, config = {}) {
    const where = tableHelper.whereFilters(
      filterStatus,
      receivedSamplesFilters
    );
    return http.request({
      method: 'get',
      url: '/samples/count',
      params: { where },
      ...config,
    });
  },
  // Raw-where variant of count() — bypasses tableHelper (used by monitoring detail panel)
  countWhere(where, config = {}) {
    return http.request({
      method: 'get',
      url: '/samples/count',
      params: { where },
      ...config,
    });
  },
  // Raw-where variant of index() — bypasses tableHelper (used by monitoring detail panel)
  indexWhere(tableFilters, where, config = {}) {
    return http.request({
      method: 'get',
      url: '/samples',
      params: { filter: { ...tableFilters, where } },
      ...config,
    });
  },
  show(sampleId, config = {}) {
    return http.request({
      method: 'get',
      url: `/samples/${sampleId}`,
      ...config,
    });
  },
  // bulkUpdate(data, whereCondition) {
  //   return http.request({
  //     method: 'patch',
  //     url: `/samples`,
  //     params: { where: whereCondition },
  //     data,
  //   });
  // },
  patchSample(sampleId, data) {
    return http.request({
      method: 'patch',
      url: `/samples-infos/${sampleId}`,
      data,
    });
  },
  downloadDetails(sampleId, config = {}) {
    return http.request({
      method: 'get',
      url: `/samples/${sampleId}/details-pdf`,
      responseType: 'blob',
      ...config,
    });
  },
  downloadAttachmentsZip(labSampleId, config = {}) {
    return http.request({
      method: 'get',
      url: `/samples/${labSampleId}/attachments-zip`,
      responseType: 'blob',
      ...config,
    });
  },
  samplesAnalysesIndex(sampleId, config = {}) {
    return http.request({
      method: 'get',
      url: `/samples/${sampleId}/analyses`,
      params: {
        printOnWorksheet: true,
      },
      ...config,
    });
  },
  samplesAnalysesMultiple(labSampleIds, printOnWorksheet = true, config = {}) {
    const params = {
      labSampleIds: [...labSampleIds],
    };
    if (printOnWorksheet) params.printOnWorksheet = true;
    return http.request({
      method: 'get',
      url: '/samples/analyses',
      params,
      ...config,
    });
  },
  printSampleReport(sampleId, config = {}) {
    return http.request({
      method: 'get',
      url: `/samples/${sampleId}/test-report-pdf`,
      responseType: 'blob',
      ...config,
    });
  },
  getSampleReports(sampleId, config = {}) {
    return http.request({
      method: 'get',
      url: `/samples/${sampleId}/test-reports`,
      ...config,
    });
  },
  getSampleReport(sampleId, reportId, config = {}) {
    return http.request({
      method: 'get',
      url: `/samples/${sampleId}/test-reports/${reportId}`,
      responseType: 'blob',
      ...config,
    });
  },
  // samplesAnalysesCount(sampleId) {
  //   const filter = { where: { sampleId } };
  //   return http.request({
  //     method: 'get',
  //     url: `/sampleanalysis/count`,
  //     params: { filter },
  //   });
  // },
  getSampleOperationValues(valueId, config = {}) {
    return http.request({
      method: 'get',
      url: `/laboratory-sample-analyses/operation-values/${valueId}`,
      ...config,
    });
  },
  insertSampleOperationValues(data) {
    return http.request({
      method: 'post',
      url: '/laboratory-sample-analyses/operation-values',
      data,
    });
  },
  // `source` is the changelog provenance (only 'fileImport' is accepted);
  // omit it for manual edits, axios then leaves it out of the query string.
  updateSampleOperationValues(valuesId, data, source) {
    return http.request({
      method: 'patch',
      url: `/laboratory-sample-analyses/operation-values/${valuesId}`,
      params: { source },
      data,
    });
  },
  bulkUpdateRawData(sampleIds, payload) {
    const data = {
      sampleIds,
      ...payload,
    };
    return http.request({
      method: 'post',
      url: '/laboratory-sample-analyses/operation-values/bulkrawdata',
      data,
    });
  },
  updateRawData(sampleId, data) {
    return http.request({
      method: 'post',
      url: `/samples/${sampleId}/operation-values/rawData`,
      data,
    });
  },
  createRevisionDefault(labSampleId, data) {
    return http.request({
      method: 'post',
      url: `/samples/${labSampleId}/revision/default`,
      data,
    });
  },
  createRevisionChallenge(
    { labSampleId, report, position, data },
    isAdvancedRevision = false
  ) {
    const bodyFormData = new FormData();
    bodyFormData.append('report', report);
    bodyFormData.append('position', JSON.stringify(position));
    bodyFormData.append('data', JSON.stringify(data));
    const path = isAdvancedRevision
      ? `/admin/advanced-revision/${labSampleId}/challenge`
      : `/samples/${labSampleId}/revision/challenge`;
    return http.request({
      method: 'post',
      url: path,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: bodyFormData,
    });
  },
  getSampleActions(sampleId, config = {}) {
    return http.request({
      method: 'get',
      url: `/samples/${sampleId}/actions`,
      ...config,
    });
  },
  executeSampleAction(sampleId, data) {
    return http.request({
      method: 'patch',
      url: `/samples/${sampleId}/action`,
      data,
    });
  },
  sampleAnalysesSearch({ filters, printType, printFilters }, config = {}) {
    return http.request({
      method: 'post',
      url: '/samples/search',
      params: {
        where: filters,
      },
      data: { printFilters, printType },
      responseType: 'blob',
      ...config,
    });
  },
  sampleAnalysesSearchCount(filters, config = {}) {
    return http.request({
      method: 'get',
      url: '/samples/search/count',
      params: { where: filters },
      ...config,
    });
  },
  sampleAnalysesSearchExport(
    { filters, printType, printFilters },
    config = {}
  ) {
    return http.request({
      method: 'post',
      url: '/samples/search/export',
      params: {
        where: filters,
      },
      data: { printFilters, printType },
      responseType: 'blob',
      ...config,
    });
  },
  autocompleteFetch(key, value, exact = false, config = {}) {
    const filter = {
      where: {
        [key]: exact ? value : { regexp: `/${value}/i` },
      },
      // Limit autocomplete results to prevent connection pool saturation
      // Autocomplete dropdowns don't need hundreds of results
      limit: 20,
    };
    return http.request({
      method: 'get',
      url: '/samples',
      params: { filter },
      ...config,
    });
  },
  analysisPrintExcel(printType, data, config = {}) {
    return http.request({
      method: 'post',
      url: `/samples/analysis-print-excel?type=${printType}`,
      data,
      responseType: 'blob',
      ...config,
    });
  },
  analysisPrintPdf(printType, data, config = {}) {
    return http.request({
      method: 'post',
      url: `/samples/analysis-print-pdf?type=${printType}`,
      data,
      responseType: 'blob',
      ...config,
    });
  },
  /** This will get all accepted or in progress/verification samples */
  getSamplesFromGroupingId(groupingId, config = {}) {
    const filters = {
      where: {
        and: [
          { groupingId },
          {
            status: {
              inq: [
                LAB_SAMPLE_STATUSES.ACCEPTED,
                LAB_SAMPLE_STATUSES.INPROGRESS,
                LAB_SAMPLE_STATUSES.TOBEVERIFIED,
              ],
            },
          },
        ],
      },
    };
    return http.request({
      method: 'GET',
      url: '/samples',
      params: { filter: filters },
      ...config,
    });
  },
  sendPdfToSign(labSampleId, report, position) {
    const bodyFormData = new FormData();
    bodyFormData.append('report', report);
    bodyFormData.append('position', JSON.stringify(position));
    return http.request({
      method: 'post',
      url: `/samples/${labSampleId}/test-reports`,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data: bodyFormData,
    });
  },
  removeUploadedReport(labSampleId) {
    return http.request({
      method: 'delete',
      url: `/samples/${labSampleId}/test-reports`,
    });
  },
  patchSamplingInfo(labSampleId, data) {
    return http.request({
      method: 'patch',
      url: `/samples/${labSampleId}/sampling-info`,
      data,
    });
  },
  samplesSymbolsSearch(tableFilters, filterStatus, config = {}) {
    const filters = tableHelper.whereFilters(filterStatus, symbolSearchFilters);
    return http.request({
      method: 'get',
      url: '/samples/search-symbols',
      params: { filter: { ...tableFilters, where: filters } },
      ...config,
    });
  },
  samplesSymbolsSearchCount(filterStatus, config = {}) {
    const where = tableHelper.whereFilters(filterStatus, symbolSearchFilters);
    return http.request({
      method: 'get',
      url: '/samples/search-symbols/count',
      params: { where },
      ...config,
    });
  },
  checkChanges(config = {}) {
    return http.request({
      method: 'get',
      url: '/samples/edit-requests/count',
      ...config,
    });
  },
  /**
   *
   * @param {string} sampleId
   * @param {string} labNotes
   * @returns {Promise<any>}
   */
  update(sampleId, labNotes) {
    return http.request({
      method: 'patch',
      url: `/samples/${sampleId}/lab-notes`,
      data: { labNotes },
    });
  },
};

export default samples;
